import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f979d32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view" }
const _hoisted_2 = { class: "show" }


import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import TextTable from "./TextTable.vue";
import {TextFieldType} from "@/components/business/crud/interface/FieldType";


export default /*#__PURE__*/_defineComponent({
  __name: 'TextForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();

function ellipsis(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length <= max) {
    return text;
  } else {
    return text.slice(0, max - 3) + "..."
  }
}

function showLong(text: string | undefined, max: number) {
  if (!text) {
    return "";
  }
  if (text.length > max) {
    return text;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createVNode(_component_a_input, {
      value: _unref(data)[_ctx.propName],
      "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data)[_ctx.propName]) = $event)),
      maxlength: _ctx.widget.length,
      placeholder: '请填写' + _ctx.info.title
    }, null, 8, ["value", "maxlength", "placeholder"]), [
      [_vShow, _ctx.info.status === 'edit']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tooltip, {
        title: showLong(_unref(data)[_ctx.propName], 30),
        placement: "top"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(ellipsis(_unref(data)[_ctx.propName], 30)), 1)
        ]),
        _: 1
      }, 8, ["title"])
    ], 512), [
      [_vShow, _ctx.info.status === 'show']
    ])
  ], 64))
}
}

})